import React from 'react';
import Navbar from '../Navbar/Navbar';
import Footer from '../Footer';
import { useTranslation } from 'react-i18next';

const ErrorFallback = () => {
  const { t } = useTranslation();

  return (
    <>
      <Navbar />
      <main className="flex flex-col justify-center items-center gap-[12px] self-center grow max-w-[500px] text-center px-[8px]">
        <h1 className="title-lg"> {t('errorFallback.title')} </h1>
        <p className="p1-medium">
          {t('errorFallback.text')}{' '}
          <a href="mailto:contact@oveit.com" className="text-blue-1000">
            contact@oveit.com
          </a>
        </p>
      </main>
      <Footer />
    </>
  );
};

export default ErrorFallback;
